import React from "react";
import "./style.css";

function About() {
  return (
    <div className="background flex about-background" id="about">
      <div className="about-header-border">
        <h2 id="about-header">About</h2>
      </div>
      <section id="about-section">
        <p>
          I'm a software engineer building scalable, user-first tools at Braven. With a background in education and journalism, I bring a unique perspective to solving real-world problems. I ship features end-to-end and collaborate cross-functionally with product, design and data teams. I recently completed the Overclock AI Engineering Fellowship, focused on honing prompt engineering and AI-accelerated workflows. I thrive in ambiguity and am passionate about delivering the best possible experience for end users.
        </p>
      </section>
    </div>
  );
}

export default About;
